import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnChanges } from '@angular/core';
import { DsScoreModule, DsScoreSize } from '@levelaccess/design-system';
import { IChatV2ComponentChunk } from '@shared/interfaces/ai-executor.interface';

@Component({
  selector: 'app-ai-chat-score',
  template: `
    <div *ngIf="title" class="fw-semibold mb-2">{{ title }}</div>
    <ds-score [value]="value" [size]="size">
      <span *ngIf="label" ds-score-description>{{ label }}</span>
    </ds-score>
  `,
  styleUrls: ['./ai-chat-score.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, DsScoreModule],
  standalone: true,
})
export class AiChatScoreComponent implements OnChanges {
  @Input() public chunk: IChatV2ComponentChunk;

  public title: string = '';
  public label: string = '';
  public value: number | null = null;
  public size: DsScoreSize = DsScoreSize.big;

  constructor(private changeDetectorRef: ChangeDetectorRef) {}

  public static serialize(data: Record<string, unknown>): string {
    const title = (data['title'] as string) ?? '';
    const label = (data['label'] as string) ?? '';
    const value = (data['value'] as number | null) ?? null;

    const heading = [title, label].filter(Boolean).join(' - ');
    return heading ? `${heading}: ${value}` : `${value}`;
  }

  public ngOnChanges(): void {
    const data = this.chunk?.data ?? {};
    this.title = (data['title'] as string) ?? '';
    this.label = (data['label'] as string) ?? '';
    this.value = (data['value'] as number) ?? null;

    const rawSize = data['size'] as string;
    this.size =
      rawSize && Object.values(DsScoreSize).includes(rawSize as DsScoreSize) ? (rawSize as DsScoreSize) : DsScoreSize.big;

    this.changeDetectorRef.detectChanges();
  }
}
